import React,{useState} from 'react'

function DropDownBox(props) {
    const [dropOpen , setDropOpen] = useState(false)
  return (
    <div
      className={`dropdown-box container my-2`}
      onClick={() => {
        setDropOpen((prev) => {
          return !prev;
        });
      }}
      style={dropOpen ? {backgroundColor:"white",padding:"15px",borderRadius:"15px",boxShadow: "0px 4px 11px 2px rgba(0, 0, 0, 0.08)",webkitBoxShadow: "0px 4px 11px 2px rgba(0,0,0,0.08)",mozBoxShadow:"0px 4px 11px 2px rgba(0,0,0,0.08)"}:{backgroundColor:"transparent"}}
    >
      <div className="box-head d-flex align-items-center justify-content-between gap-3">
        <h5 className="title mb-0" >{props.title}</h5>
        <img src={dropOpen ? '/images/icons/faq-less.png':'/images/icons/faq-add.png'} className='eye-icon' alt='dropdown-icon'/>
      </div>
      <div className="box-content my-3" style={dropOpen?{animation:"bottomBoxOpen .6s ease-in-out",display:"block"}:{display:"none"}}>
          {props?.setHtml? <p className='mb-0' dangerouslySetInnerHTML={{__html:props.content}}></p>:  <p className='mb-0'>{props.content}</p> }
      </div>
    </div>
  );
}

export default DropDownBox